const Colors = {
  white: '#FFFFFF',
  black: '#0D0D0D',
  purple: '#351068',
  lightPurple: '#9a4af3',
  grey: '#B0B8C1',
  lightGrey: '#CCCCCC',
};

export default Colors;
